import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useNavigate } from 'react-router'
import { BLUE, YELLOW, lockedFont } from './constants'

interface WelcomeBannerProps {
    title: string
    description: string
    buyNowText: string
}

const WelcomeBanner = ({ title, description, buyNowText }: WelcomeBannerProps) => {
    const navigate = useNavigate()

    return (
        <Stack sx={{ bgcolor: YELLOW, p: '30px 40px', flexShrink: 0 }} spacing={1} data-testid="welcome-banner-stack-typography">
            <Typography
                variant="h2"
                sx={{
                    ...lockedFont('25px', '34px'),
                    fontFamily: 'var(--font-poppins)',
                    color: BLUE,
                    fontWeight: 700
                }}
                dangerouslySetInnerHTML={{ __html: title }}
                data-testid="welcome-banner-typography-1"
            />
            <Typography
                component="div"
                sx={{
                    ...lockedFont('13px', '18px'),
                    fontFamily: 'var(--font-poppins)',
                    color: BLUE,
                    fontWeight: 400,
                    '& p': { margin: 0, display: 'inline' },
                    '& p + p::before': { content: '" "' }
                }}
                dangerouslySetInnerHTML={{ __html: description }}
                data-testid="welcome-banner-typography-2"
            />
            <Box sx={{ mt: '15px !important' }} data-testid="welcome-banner-box-button">
                <Button
                    variant="contained"
                    onClick={() => navigate('/products')}
                    disableRipple
                    disableFocusRipple
                    disableTouchRipple
                    disableElevation
                    sx={{
                        ...lockedFont('20px', '24px'),
                        fontFamily: 'var(--font-poppins)',
                        bgcolor: BLUE,
                        color: '#FFFFFF',
                        textTransform: 'none',
                        borderRadius: 999,
                        fontWeight: 600,
                        height: 40,
                        px: 2.5,
                        py: 0,
                        boxShadow: 'none',
                        transition: 'none',
                        '&:hover, &:active, &:focus, &.Mui-focusVisible': {
                            bgcolor: BLUE,
                            color: '#FFFFFF',
                            boxShadow: 'none'
                        }
                    }}
                    data-testid="welcome-banner-button">
                    {buyNowText}
                </Button>
            </Box>
        </Stack>
    )
}

export default WelcomeBanner
